import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";
@Component({
  selector: 'app-payment-paybyrd-modal',
  templateUrl: './payment-paybyrd-modal.component.html',
  styleUrls: ['./payment-paybyrd-modal.component.scss']
})
export class INDRAPaymentPaybyrdModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {
    
    url: string = "";
    urlSafe: SafeResourceUrl;
    showLoading = false;
    errMsg: string = "";
    resizeEventEnabled: boolean = false;

    constructor(
        private cdr: ChangeDetectorRef,
        protected modalService: ModalService,
        public sanitizer: DomSanitizer,
        private ibeAdminConfigService: INDRAIbeAdminConfigService,
    ) { 
        super(modalService)
    }
  
    ngOnInit() {
       this.INDRA_loadPaybyrd();
    }

    INDRA_loadPaybyrd(){
        
        const configData = { compact: true }
        const configs = btoa(JSON.stringify(configData));
        const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue('externalURLs.paybyrdPaymentUrl');
        const resizeEvent = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.paybyrdResizeEventEnabled');
        if (resizeEvent == "true") {
            this.resizeEventEnabled = JSON.parse(resizeEvent);
        }

        if(this.data[0].status === '200' && this.data[0].errors.length != 1) {  
            this.showLoading = true;
            const urlNavigate = urlIbeAdmin.replace('{CHECKOUT_ID}', `${this.data[0].data.checkoutKey}`).replace('{ORDER_ID}', `${this.data[0].data.orderId}`).replace('{CONFIGS}', `${configs}`);

            // urlNavigate contains config, checkoutUrl don't.
            this.url = urlIbeAdmin ? urlNavigate: this.data[0].data.checkoutUrl;
            this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
        } else {
            this.errMsg = this.data[0].errors[0].desc;
        }

        

        if (this.resizeEventEnabled) {
            window.addEventListener('message', (event) => {
                // extracts data from the received message
                // const { type = null, payload = null } = event && event.data ? event.data || {} : {};
                const { type = null, payload = null } = event.data || {};
                
                //validates if the message corresponds to the correct event
                if (type === 'PAYBYRD_HOSTED_FORM_WINDOW_RESIZE') {
                    const { height, width } = payload;
                    
                    // Selects iframe for the ID
                    const iframeWrapper = document.getElementById('iframe-element');
                    
                    // Adjusts dinamically height of the iframe
                    // Width adjustment not necessary
                    if (iframeWrapper) {
                        // iframeWrapper.style.width = `${width}px`;
                        iframeWrapper.style.height = `${height}px`;
                    }
                }
            });
        }
    }



    INDRA_close() {
        this.closeModal();
    }

    onLoad() {
        this.showLoading = false;
    }

    ngOnDestroy() {
    }

    ngAfterContentChecked(): void {
        this.cdr.detectChanges();
     }  

}
